import React from 'react';

import Skeleton, {
  SKELETON_SIZES,
  SKELETON_WIDTHS
} from 'buyside/components/presentation/Skeleton/skeleton';
import ProfileImage from 'buyside/components/presentation/ProfileImage/profileImage';

import { defaultUserImageUrl } from 'buyside/util/urlHelper';

import styles from './navigationMessagesStyles.scss';

const NavigationMessageLoading: React.FC = () => {
  return (
    <div className={styles.message}>
      <div className={styles.messageHeader}>
        <ProfileImage noMargin size="small" source={defaultUserImageUrl()} />
        <div className={styles.senderInfo}>
          <Skeleton width={SKELETON_WIDTHS.MEDIUM} size={SKELETON_SIZES.SMALL} />
          <Skeleton width={SKELETON_WIDTHS.ONE_THIRD} size={SKELETON_SIZES.SMALL} />
        </div>
      </div>
      <div>
        <Skeleton width={SKELETON_WIDTHS.FULL} size={SKELETON_SIZES.SMALL} />
        <Skeleton width={SKELETON_WIDTHS.FULL} size={SKELETON_SIZES.SMALL} />
      </div>
    </div>
  );
};

export default NavigationMessageLoading;
